import Box from "@amzn/awsui-components-react-v3/polaris/box";

export default function Error() {
  return <Box variant="h1">Unauthenticated</Box>;
}